import { IInstitucionSNP } from '@/shared/model/institucionSNP.model';
import { Programa } from '@/shared/model/programa.model';
import { ISedeSNP } from '@/shared/model/sedesSNP.model';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class HeaderProgramaComponent extends Vue {
  @Prop({ required: true })
  public programa: Programa;

  public institucion: IInstitucionSNP = {};
  public sede: ISedeSNP = {};
  public esPostulante = false;

  public mounted(): void {
    (this.programa?.instituciones ?? []).forEach(institucion => {
      (institucion.sedes ?? []).forEach(sede => {
        if (sede.postulante) {
          this.esPostulante = true;
          this.institucion = institucion;
          this.sede = sede;
        }
      });
    });
  }
}
